import type {
  NotificationsView,
  NotificationsViewContextData,
} from "./notifications-view.type";

import { useState } from "react";

import { NOTIFICATIONS_VIEWS_INVALIDATE_SUFFIXES } from "./notifications-view.constant";

export const useNotificationsViewProvider = (
  view: NotificationsView
): NotificationsViewContextData => {
  const [isFetching, setIsFetching] = useState(false);
  const invalidateSuffixes = NOTIFICATIONS_VIEWS_INVALIDATE_SUFFIXES[view];

  return {
    view,
    isFetching,
    setIsFetching,
    invalidateSuffixes,
  };
};
